<!-- FullLoader.vue-->
<template>
    <transition enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut">
        <div v-if="isLoading" :class="{'white-overlay': overlay}">
            <vue-progress-bar v-if="brand === 'HC'" style="background-color: #62BB46" />
            <vue-progress-bar v-else />
            <div class="loader-wrapper">
                <div v-if="label" class="pulled-left" style="padding: 10px 20px ">{{label}}</div>
                <div class="wrapper">
                    <div class="spinner-container">
                        <img alt="loader" src="../../../Images/spinner.gif" />
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    // Importing Packages
    import { createApp, ref, watch, onMounted, onBeforeUpdate, getCurrentInstance } from 'vue';
    import axios from 'axios';

    const siteLang = document.documentElement.lang;

    export default {
        name: 'FullLoader',
        props: {
            label: {
                default: 'Loading...'
            },
            isLoading: {
                type: Boolean,
                required: true,
            },
            overlay: {
                default: true
            }
        },
        setup(props) {
            const latencyThreshold = ref(100);
            const applyOnHttp = ref(true);
            let requestsTotal = ref(0);
            let requestsCompleted = ref(0);
            const brand = ref(siteBrand.toUpperCase());
            const internalInstance = getCurrentInstance();

            const np = internalInstance.appContext.config.globalProperties.$Progress;

            const setComplete = () => {
                requestsTotal.value = 0
                requestsCompleted.value = 0
                np.finish()
            }

            const initProgress = () => {
                if (0 === requestsTotal.value) {
                    setTimeout(() => np.start(), latencyThreshold.value)
                }
                requestsTotal.value++;
                np.set(requestsCompleted.value / requestsTotal.value)
            }

            const increase = () => {
                // Finish progress bar 50 ms later
                setTimeout(() => {
                    ++requestsCompleted.value
                    if (requestsCompleted.value >= requestsTotal.value) {
                        setComplete()
                    } else {
                        np.set((requestsCompleted.value / requestsTotal.value) - 0.1)
                    }
                }, latencyThreshold.value + 50)
            }

            if (np) {
                axios.interceptors.request.use(
                    (request) => {
                        // Start the progress bar
                        request.showProgressBar = applyOnHttp.value
                        if (request.showProgressBar) { initProgress() }
                        return request
                    },
                    (error) => {
                        return Promise.reject(error);
                    }
                );

                axios.interceptors.response.use(
                    (response) => {
                        if (response.showProgressBar) increase()
                        return response;
                    },
                    (error) => {
                        // Stop the progress bar
                        if (error.config && error.config.showProgressBar) increase()
                        return Promise.reject(error);
                    }
                );
            }

            return {
                latencyThreshold,
                applyOnHttp,
                requestsTotal,
                requestsCompleted,
                setComplete,
                initProgress,
                increase,
                brand
            }
        }
    };

</script>

<style scoped>
    .white-overlay {
        background-color: rgba(255, 255, 255, 0.75);
        z-index: 9999;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
        position: fixed;
        margin: 0;
    }

    .loader-wrapper {
        position: absolute;
        display: inline-block;
        top: 50%;
        margin-top: -6em;
        left: 50%;
        width: max-content;
        transform: translate(-50%);
    }


    .pulled-left {
        float: left;
        margin-top: 10px;
    }

    *, *:before, *:after {
        box-sizing: border-box;
    }

    .wrapper {
        position: relative;
        display: inline-block;
        width: 40px;
        height: 40px;
        font-size: 0;
    }

    .spinner-container {
        width: 100%;
        height: 100%;
        -webkit-animation: container-rotate 1568ms linear infinite;
    }
</style>


